<app-project-base
  [project]="project"
  [datasetTiles]="datasetTiles"
  [resourceTiles]="resourceTiles"
  [metaTableData]="metaTableData"
>
  @if (project()?.flags?._can_update_meta) {
    <a
      project-details-actions
      [routerLink]="pdeRoutes.projectEditDetails(privateProject().id)"
      mat-button
      class="edit-button"
    >
      <mat-icon class="material-symbols-outlined">edit</mat-icon>
      Edit
    </a>
  }

  @if (privateProject()?.visible_to_all_users) {
    <div project-toolbar-extra>
      <a [routerLink]="pdcRoutes.projectView(project()?.id)" class="content-header-action toolbar-action">
        <mat-icon class="material-symbols-outlined">security</mat-icon>
        View in Public Data Commons
      </a>
    </div>
  }

  <div class="access-section" project-access>
    <div class="meta-header">
      <h3>Project Access</h3>
      @if (permissionsContext?.showEditButton) {
        <a mat-button [routerLink]="getEditLink()">
          <mat-icon class="material-symbols-outlined">edit</mat-icon>
          Edit
        </a>
      }
    </div>

    <div project-visibility>
      <h3 class="meta-subheader flat">Public Data Commons Project Details Visibility</h3>
      <div class="meta-subcontent flat">
        @if (privateProject()?.visible_to_all_users) {
          Visible in the Public Data Commons
        } @else {
          Not visible in the Public Data Commons
        }
      </div>
    </div>

    <div class="meta-subcontent">
      <app-permissions-table
        project-permissions
        [rows]="permissionRows"
        [context]="permissionsContext"
      ></app-permissions-table>
    </div>

    @if (project()?.flags._can_delete_meta) {
      <div class="actions project">
        <a [routerLink]="pdeRoutes.projectEditAccessDelete(project()?.id)" matButton="filled" class="delete danger">
          <mat-icon class="material-symbols-outlined">delete</mat-icon>Delete
        </a>
      </div>
    }
  </div>

  <app-file-table
    private-project-documents
    [container]="privateProject"
    [flags]="project()?.flags"
    tablename="Private Project Document"
  ></app-file-table>
</app-project-base>
